import images from "@assets/images";
import { CommonActions, useNavigation, useRoute } from "@react-navigation/native";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectAuthLoggedIn } from "@src/ducks/slices/auth.slice";
import { ImageButton } from "components/button";
import React from "react";
import { Image, View } from "react-native";
import { Scale } from "utils/animation";
import useStyles from "./styles.css";

const BitpacePopupResult = () => {
  const styles = useStyles();
  const route = useRoute<any>();
  const status = route.params?.status;
  const navigation = useNavigation<any>();
  const isLoggedIn = useAppSelector(selectAuthLoggedIn);

  const onClose = () => {
    navigation.dispatch(
      CommonActions.reset({
        index: 1,
        routes: [
          { name: isLoggedIn ? "Home" : "SignInOption" },
        ],
      })
    );
  };

  return (
    <View style={styles.container}>
      <Scale style={styles.container}>
        <View style={styles.center_view}>
          <Image
            style={styles.i_background}
            source={{
              uri: status === "success"
                ? images.bitpace_success
                : images.bitpace_error
            }}
            resizeMode="stretch"
          />
          <ImageButton
            onPress={onClose}
            style={styles.btn_close}
            source={{uri: images["btn-close-red"]}}
          />
        </View>
      </Scale>
    </View>
  );
};

export default BitpacePopupResult;
